import BasicRepository from "./basicRepository";
import Client from "../client";
import {VariableSetResource} from "../resources/variableSetResource";

class VariableRepository extends BasicRepository<VariableSetResource> {
    constructor(client: Client) {
        super("Variables", client);
    }
    names(projectId: string, projectEnvironmentsFilter: any): Promise<string[]> {
        return this.client.get(this.client.getRootDocument().Links["VariableNames"], {
            project: projectId,
            projectEnvironmentsFilter: projectEnvironmentsFilter ?
                projectEnvironmentsFilter.join(",") : projectEnvironmentsFilter
        });
    }
    nonPrintableChars(variableSet: any) {
        return this.client.post(this.client.getRootDocument().Links["VariablesNonPrintableChars"], variableSet);
    }
}

export default VariableRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/variableRepository.ts